import React, { Component } from 'react'
import { RankingIQStyle } from './../../styles'
import { connect } from 'react-redux'

const RAD = (x) =>  251.327412287 - (251.327412287 * x / 100 )

class RankingIQ extends Component {
  state = {
    score: 0
  }

  render() {
    const { preview, score } = this.props
    const real_score = parseInt(score) / 10
    return (
      <div className={`ranking-iq ${RankingIQStyle(preview, RAD(real_score))}`}>
        <div className='ranking-iq-inner'>
          <div className='label'>My RM IQ</div>
          <div className='score'> {score} </div>
        </div>
        <div className="ranking-iq-progress">
          <svg  viewBox="0 0 100 100">
            <circle className="progress" cx="50" cy="50" r="40"  />
            <circle className="progress-bar" cx="50" cy="50" r="40"  />
          </svg>
        </div>
      </div>
    )
  }
}


export default connect(
  ({ Session }) => ({
    score: Session.challenge.rankingIQ
  })
)(RankingIQ)


// WEBPACK FOOTER //
// ./src/components/Challenge/RankingIQ.js